import React from "react";
import FooterPanel from "../../layout/FooterPanel";
import { Link } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { DocumentSources } from "../../cpm/DocumentSources";
import { SourcesListPanelLoader } from "../../cpm/SourcesListPanelLoader/SourcesListPanelLoader";
import { useDocumentSourcePanel } from "./DocumentSourcePanelHook";
import HeaderPanel from "../../layout/HeaderPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";

export interface DocumentSourcesPanelProps {
  idPartRoot: string;
}

export const DocumentSourcesPanel: React.FunctionComponent<DocumentSourcesPanelProps> = (props) => {
  const defaultHeaderName = formatMessage("cof.documentsources.viewall.subtitle");
  const { isViewList, headerName, documentSourceTree, selectedSource, onItemSingleClick, goBack, loadViewList } =
    useDocumentSourcePanel(props);

  const title = formatMessage("cof.documentsources.header");

  if (isViewList)
    return (
      <>
        <HeaderPanel applyPadding>{title}</HeaderPanel>
        <SourcesListPanelLoader
          headerName={headerName}
          documentPartTreeSelection={selectedSource}
          idPartRoot={props.idPartRoot}
        />
        <FooterPanel>
          <PrimaryButton className={ButtonVariants.white} text={formatMessage("cof.base.back")} onClick={goBack} />
        </FooterPanel>
      </>
    );
  return (
    <>
      <HeaderPanel applyPadding>{title}</HeaderPanel>
      <DocumentSources onItemSingleClick={onItemSingleClick} data={documentSourceTree} idPartRoot={props.idPartRoot} />
      <FooterPanel>
        <Link
          style={{ textDecoration: "none" }}
          onClick={() => loadViewList(defaultHeaderName)}
          className={ButtonVariants.link}
        >
          {formatMessage("cof.documentsources.viewall")}
        </Link>
      </FooterPanel>
    </>
  );
};
